import * as types from './types'

const initialState = {
  logs: null,
  pending: false,
  error: null,
  params: { hours: 1, top: 10 }
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.LOAD_LOGS_ATTEMPT:
      return {
        ...state,
        logs: null,
        pending: true,
        error: null
      }
    case types.LOAD_LOGS_SUCCESS:
      return {
        ...state,
        logs: action.logs,
        pending: false,
        error: null
      }
    case types.LOAD_LOGS_FAILURE:
      return {
        ...state,
        logs: null,
        pending: false,
        error: action.error
      }
    case types.SET_PARAMS:
      return {
        ...state,
        params: { hours: action.hours, top: action.top }
      }
    case types.RESET_MONITORING:
      return { ...initialState }
    default:
      return state
  }
}
